import React from "react";

export interface WorkflowCardData {
  num: string;
  title: string;
  sub: string;
  body: React.ReactNode;
  screenshot?: string;
  screenshotAlt?: string;
  replacesLabel: string;
  replacesItems: string;
}

interface WorkflowsSectionProps {
  id?: string;
  eyebrow: React.ReactNode;
  heading: React.ReactNode;
  intro: React.ReactNode;
  workflows: WorkflowCardData[];
}

const WorkflowsSection: React.FC<WorkflowsSectionProps> = ({
  id,
  eyebrow,
  heading,
  intro,
  workflows,
}) => {
  return (
    <section id={id} className="cs-section cs-surfaces">
      <div className="cs-surfaces-inner">
        <div className="cs-surfaces-head">
          <div className="eyebrow">{eyebrow}</div>
          <h2>{heading}</h2>
          <p>{intro}</p>
        </div>

        <div className="cs-workflows-grid">
          {workflows.map((wf) => (
            <article key={wf.num} className="cs-workflow-card">
              <div className="cs-workflow-content">
                <div className="cs-workflow-num">{wf.num}</div>
                <h3>{wf.title}</h3>
                <p className="cs-workflow-sub">{wf.sub}</p>
                <p className="cs-workflow-body">{wf.body}</p>
                <div className="cs-workflow-replaces">
                  {wf.replacesLabel}
                  <span className="items">{wf.replacesItems}</span>
                </div>
              </div>
              {wf.screenshot && (
                <div className="cs-workflow-screenshot">
                  <img src={wf.screenshot} alt={wf.screenshotAlt ?? wf.title} />
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkflowsSection;
